import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b392587"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "page-7",
  class: "page-7"
}
const _hoisted_2 = { class: "step d-block d-md-none" }
const _hoisted_3 = ["src"]

import ResponsiveImage from '../responsive-image.vue';
import ImageStepM from './step-m.png';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ResponsiveImage, {
      image: require('./bg.jpg'),
      "image-webp": require('./bg.webp'),
      "mobile-image": require('./bg-m.jpeg'),
      "mobile-image-webp": require('./bg-m.webp'),
      "image-h": 1548,
      "image-w": 3840,
      "mobile-image-h": 1365,
      "mobile-image-w": 1170
    }, null, 8, ["image", "image-webp", "mobile-image", "mobile-image-webp"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", { src: _unref(ImageStepM) }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})